import DataRequest from "./DataRequest";
import { useQuery } from "react-query";
import { Defect, NotableItem } from "../types/responses/gradingResponse";
import { getDefectMappings } from "@idwal/idwal-utilities";

export const getNotableItems = (inspectionId: string) => {
    return useQuery<NotableItem[] | Defect[]>("notableItems", async () => {
        return await DataRequest(inspectionId, "notable-items");
    });
};

export const getAuthorityMappings = (releaseAuthorityMappings: boolean) => {
    return useQuery<Record<string, string[]>>("authorityMappings", () => {
        if (releaseAuthorityMappings) {
            return getDefectMappings();
        }

        return {}
    });
}
